import numberTemplate from './template/value/number.pug';
import stringTemplate from './template/value/string.pug';
import selectEnumTemplate from './template/value/enum-select.pug';
import selectBooleanTemplate from './template/value/boolean-select.pug';
import checkboxEnumTemplate from './template/value/enum-checkbox.pug';
import radioEnumTemplate from './template/value/enum-radio.pug';
import booleanTemplate from './template/value/boolean.pug';
import radioBooleanTemplate from './template/value/boolean-radio.pug';
import dateTemplate from './template/value/date.pug';
import groupedCheckboxTemplate from './template/value/grouped-checkbox.pug';
import textareaTemplate from './template/value/textarea.pug';

export {
  numberTemplate as integer,
  numberTemplate as number,
  stringTemplate as string,
  selectEnumTemplate as selectEnum,
  checkboxEnumTemplate as checkboxEnum,
  radioEnumTemplate as radioEnum,
  radioBooleanTemplate as radioBoolean,
  booleanTemplate as boolean,
  dateTemplate as datetime,
  groupedCheckboxTemplate as category,
  selectBooleanTemplate as selectBoolean,
  textareaTemplate as textarea,
};
